<template>
  <b-modal size="lg" ref="modal" @hidden="flush" centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <h5 class="font-weight-bolder m-0">
        <span>Add New Financing Candidate</span>
      </h5>

      <b-button
        size="sm"
        variant="none"
        class="btn-icon btn-circle btn-hover-dark"
        title="Close"
        @click="close"
        v-b-tooltip.hover
      >
        <i class="material-icons icon-xl">close</i>
      </b-button>
    </template>

    <template #default>
      <validation-observer ref="observer">
        <div
          class="alert text-center font-weight-bold"
          :class="variants"
          v-html="error || '&nbsp;'"
          v-if="error && error.length"
        />
        <div class="row">
          <div class="col-12">
            <validation-provider
              name="name"
              rules="required|max:100"
              v-slot="{ errors }"
            >
              <b-form-group label="Company Name *" label-for="name">
                <b-form-input :disabled="disabled" v-model="candidate.name" />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <b-form-group label="Email *" label-for="email">
                <b-form-input :disabled="disabled" v-model="candidate.email" />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="phone"
              rules="max:20"
              v-slot="{ errors }"
            >
              <b-form-group label="Phone Number" label-for="phone">
                <b-form-input :disabled="disabled" v-model="candidate.phone" />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

          </div>
        </div>
      </validation-observer>
    </template>

    <template #modal-footer>
      <div class="d-flex justify-content-between mx-auto">
        <b-button
          class="btn-pill font-weight-bold"
          variant="dark"
          :disabled="disabled"
          :class="{
            'spinner spinner-success spinner-lg spinner-left': sending,
          }"
          @click.stop="submit"
        >
          <span v-if="sending">Submitting...</span>
          <span v-else>Submit</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ChatbotService from "@/services/chatbot.service";
import { formatErrorMessage } from "@/utils/random_utils";

export default {
  name: "FinancingCandidateForm",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      error: null,
      sending: false,
      disabled: false,
      candidate: {
        name: null,
        email: null,
        phone: null,
        message: null,
      },
    };
  },
  computed: {
    variants() {
      return this.error ? "alert-danger" : "";
    },
  },
  methods: {
    async submit() {
      try {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        this.sending = true;
        this.error = null;

        const response = await ChatbotService.setFinancingCandidate(this.candidate);
        
        // Emit success event
        this.$emit('candidate-added', response);
        
        // Close modal
        this.$refs.modal.hide();
        
        // Reset form
        this.flush();
        
      } catch (error) {
        this.error = formatErrorMessage(error);
      } finally {
        this.sending = false;
      }
    },

    flush() {
      this.candidate = {
        name: null,
        email: null,
        phone: null,
        company: null,
        position: null,
        notes: null,
      };
      this.error = null;
      this.sending = false;
      this.disabled = false;
      
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },

    open() {
      this.$refs.modal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-header {
  border-bottom: 1px solid #e9ecef;
}

.modal-footer {
  border-top: 1px solid #e9ecef;
}

.form-group {
  margin-bottom: 1.5rem;
}

.btn-pill {
  border-radius: 50px;
  padding: 0.75rem 2rem;
  font-weight: 600;
}

.spinner {
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
    height: 1rem;
    border: 2px solid transparent;
    border-top: 2px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% { transform: translateY(-50%) rotate(0deg); }
  100% { transform: translateY(-50%) rotate(360deg); }
}
</style> 